import {Component, Input, OnInit} from '@angular/core';
import {PartnerProduct} from "../../models/partner-product.model";

@Component({
  selector: 'app-cart-summary',
  templateUrl: './cart-summary.component.html',
  styleUrls: ['./cart-summary.component.scss'],
})
export class CartSummaryComponent implements OnInit {
  @Input() products: PartnerProduct[] = [];

  constructor() {
  }

  ngOnInit() {
  }

}
